import { render, staticRenderFns } from "./BindWeixinFail.vue?vue&type=template&id=0d9a864a"
import script from "./BindWeixinFail.vue?vue&type=script&lang=ts"
export * from "./BindWeixinFail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports